<template>
  <div>
    <div style="cursor: pointer;margin-bottom: 16px;color: #fff;" @click="back">
      <a-icon type="left" style="margin-right: 2px" />
      <span>返回</span>
    </div>

    <a-form
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 14 }"
      :colon="false"
      :form="form"
      @submit="handleSubmit"
    >
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <SelectField style="width: 90%; margin: 0.5rem auto" label="所属分类" id="category"
                         :modelValue="form.category" :options="pipeTypes" required labelWidth="40%"
                         :disabled = "view === '修改排口'"
                         @update:modelValue="(value) => handleModelValueUpdate('category', value)"
            />
        </a-col>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="编号" type="text" id="code"
                        :modelValue="form.code" placeholder="请输入编号" required
                        @update:modelValue="(value) => handleModelValueUpdate('code', value)"
            />
        </a-col>
      </a-row>
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="经纬度" type="text" id="lnglat"
                        :modelValue="form.lnglat" placeholder="请输入经纬度" inputImg
                        required @img-click="pasteLnglat" :disabled = "view === '修改排口'"
                        @update:modelValue="(value) => handleModelValueUpdate('lnglat', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="地面高程(m)" type="number" id="elevation"
                        :modelValue="form.elevation" placeholder="请输入地面高程(m)"
                        @update:modelValue="(value) => handleModelValueUpdate('elevation', value)"
            />
        </a-col>
      </a-row>
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="所在位置" type="text" id="location"
                        :modelValue="form.location" placeholder="请输入位置"
                        @update:modelValue="(value) => handleModelValueUpdate('location', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%;margin:0.5rem auto" label="附属物" type="text" id="accessary"
                        :modelValue="form.accessary" placeholder="请输入附属物"
                        @update:modelValue="(value) => handleModelValueUpdate('accessary', value)"
            />
        </a-col>
        <a-col :lg="24" :md="24" :sm="24">
            <div style="width: 95%;margin: auto;">
                <div style="color: #93a2b7;margin-bottom: 1rem;"><span style="visibility: hidden;">*</span>关联管道</div>
                <PipeTable
                        :category="form.category"
                        :list="pipeList"
                        :disabled="view === '修改排口'"
                        @change="payload => pipeList = payload"
                />
            </div>
        </a-col>
      </a-row>

      <div class="center" style="margin-top: 1rem;">
        <a-space>
            <ButtonField text="取消" @click="back" secondary />
            <ButtonField text="保存" primary @click="handleSubmit"/>
        </a-space>
      </div>
    </a-form>
  </div>
</template>
<script>
import store from "../mixins/store";
import PipeTable from "../components/pipe-table.vue";

import { mapGetters } from "vuex";

import { add, edit, fetchDetail } from "@/api/assets/outlet.js";
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";

export default {
  mixins: [store],
  components: {
      SelectField,PipeTable,ButtonField,InputField
  },
  data() {
    return {
      detail: {},
      form: {
          category:null,
          code:null,
          lnglat:null,
          elevation:null,
          location:null,
          accessary:null
      },
      pipeList: [],
      saveLoading: false,
    };
  },

  watch: {
    selectedWell: {
      handler() {
        if (this.view === "修改排口" && this.selectedWell._edit) {
          this.getDetail();
        }
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    pipeTypes() {
      return this.findDataDict("pipeType");
    },
  },

  mounted() {
    if (this.view === "修改排口" && this.selectedWell._edit) {
      this.getDetail();
    }
  },

  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
    getDetail() {
      this.detail = {};
      this.form = {
          category:null,
          code:null,
          lnglat:null,
          elevation:null,
          location:null,
          accessary:null
      }
      this.pipeList = [];
      const hide = this.$message.loading("加载中...", 0);

      fetchDetail({
        id: this.selectedWell.id,
        category: this.selectedWell.category,
      })
        .then((res) => {
          if (!res.id) return;

          this.detail = res;
          this.form.code = res.code;
          this.form.category = res.category;
          this.form.location = res.location;
          this.form.elevation = res.elevation;
          this.form.accessary = res.accessary;
          this.form.lnglat = res.x + ',' + res.y;

          if (!res.pipesFrom) {
            res.pipesFrom = [];
          }
          if (!res.pipesTo) {
            res.pipesTo = [];
          }

          this.pipeList = [
            ...res.pipesFrom.map((item) => {
              return {
                ...item,
                location: "from",
              };
            }),
            ...res.pipesTo.map((item) => {
              return {
                ...item,
                location: "to",
              };
            }),
          ];
        })
        .finally(() => {
          hide();
        });
    },

    pasteLnglat() {
      const { lng, lat } = this.selectedLnglat;
      if (!lng) {
        this.$message.error("请点击地图选择经纬度");
        return;
      }
      this.form.lnglat = lng + "," + lat
    },

    handleSubmit() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        if (!this.form.category) {
            this.$message.error('所属分类不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.code) {
            this.$message.error('编号不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.lnglat) {
            this.$message.error('经纬度不能为空');
            this.isSubmitting = false;
            return;
        }
          let flag = false;
          if (this.pipeList.length > 0) {
            this.pipeList.forEach((item) => {
              if (!item.location) {
                flag = true;
              }
            });
          }

          if (flag) {
            this.$message.error("请选择管线位置");
            return;
          }
          const arr = this.form.lnglat.split(",");
          const x = parseFloat(arr[0]);
          const y = parseFloat(arr[1]);

          let params = {
            id: this.detail.id,
            type: "drain",
            ...this.form,
            x,
            y,
            pipePolicies: this.pipeList,
          };

          let task = add;

          if (this.detail.id) {
            task = edit;
          }

          task(params).then(() => {
            this.getRainOutletList();
            this.back();
          });
    },

    back() {
      this.detail = {};
        this.form = {
            category:null,
            code:null,
            lnglat:null,
            elevation:null,
            location:null,
            accessary:null
        }
      this.pipeList = [];

      this.setSelectedLnglat({});
      this.setSelectedWell({});
      this.setSelectedPipe({});
      this.setView("排口");
    },
  },
};
</script>


<style lang="less" scoped>
.location {
  display: block;
  height: auto;
  width: 12px;
}

.center {
  padding-bottom: 24px;
}
</style>
